module.exports = __webpack_public_path__ + "img/work-slide-01.f794c0cf.jpg";